import React from "react";

export default function ExcludedMessage(props) {
    return (
        <div className="bg-city-green-light border-t border-b border-city-green-dark/70 text-city-green-dark px-4 py-3">
            <p className="text-sm">
            There has been a change in your tax status so this cannot be calculated until the next billing cycle.
            </p>
        </div>
    )
}